export const container = "bg-bg-deep min-h-screen flex items-center justify-center p-4 relative overflow-hidden font-body text-text-primary";
export const bgGlowPrimary = "absolute top-1/4 left-1/4 w-72 h-72 bg-primary-teal/10 blur-[120px] rounded-full";
export const bgGlowAccent = "absolute bottom-1/4 right-1/4 w-80 h-80 bg-accent-violet/10 blur-[130px] rounded-full";
export const glassCard = "glass-panel shadow-2xl p-6 md:p-8 max-w-md w-full flex flex-col gap-6 relative z-10";

export const headerContainer = "flex justify-between items-center border-b border-border-color pb-4";
export const headerLeft = "flex items-center gap-2.5 h-9";
export const logoImg = "w-7 h-7 object-contain";
export const titleText = "text-lg font-extrabold tracking-wide font-display text-text-primary relative leading-none";
export const titleHighlight = "relative text-primary-accent";
export const titleBadge = "absolute -top-2.5 right-0 text-[7px] font-extrabold uppercase px-1 py-0.5 rounded bg-primary-accent text-bg-deep dark:text-black leading-none";

export const langControlsContainer = "flex gap-0.5 bg-bg-deep p-0.5 rounded-lg border border-border-color";

export const headingContainer = "flex flex-col gap-1.5 text-center";
export const headingTitle = "text-lg md:text-xl font-extrabold tracking-wide";
export const headingSubtitle = "text-xs text-text-secondary";

export const errorContainer = "bg-red-500/10 border border-red-500/20 text-red-400 p-3 rounded-xl text-xs flex items-center gap-2";
export const successContainer = "bg-green-500/10 border border-green-500/20 text-green-400 p-3 rounded-xl text-xs flex items-center gap-2";

export const formContainer = "flex flex-col gap-4";
export const inputGroup = "flex flex-col gap-1.5";
export const label = "text-xs font-bold text-text-secondary";
export const inputWrapper = "flex items-center gap-2.5 bg-bg-deep border border-border-color rounded-xl px-4 py-3 w-full outline-none focus-within:border-primary-accent transition-colors";
export const iconClass = "fa-solid text-text-muted text-sm";
export const inputField = "bg-transparent border-none outline-none text-text-primary text-sm font-body w-full";

export const submitButton = "w-full bg-primary-accent text-bg-deep dark:text-black hover:opacity-90 font-bold px-4 py-3 rounded-xl text-sm transition-colors cursor-pointer flex items-center justify-center gap-2 mt-2 shadow-[0_4px_16px_rgba(0,221,255,0.2)]";

export const backLinkContainer = "text-center mt-2";
export const backLinkClass = "text-xs font-bold text-primary-accent hover:underline";

export const getLangBtnClass = (isActive: boolean) => 
  `px-1.5 py-0.5 rounded text-[10px] font-extrabold cursor-pointer transition-colors uppercase ${
    isActive 
      ? 'bg-primary-accent text-bg-deep dark:text-black' 
      : 'text-text-secondary hover:text-text-primary'
  }`;
